import React from "react";

export const FormWrapper = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="cw-flex cw-flex-col cw-flex-wrap cw-gap-4 cw-border cw-border-solid cw-border-muted cw-p-4 cw-rounded-lg cw-justify-start cw-bg-default">
      {children}
    </div>
  );
};
